import React, { useState, useEffect } from 'react';
import { compose } from 'recompose';
import { useDispatch, useSelector } from 'react-redux';
import _includes from 'lodash/includes';
import _get from 'lodash/get';
import _map from 'lodash/map';
import _reject from 'lodash/reject';

import propTypes from 'prop-types';
import { withRouter}  from 'react-router-dom';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import ViaModal from '../../../../components/library/viaModal';
import Headline from '../../../../components/library/headline';
import Button from '../../../../components/library/button';
import ItineraryToggle from '../../itineraryToggle';
import { addDetailToTraveler } from '../../../../../actions/plans';
import Paragraph from '../../../../components/library/paragraph';
import SuccessAdminAddedGroupDetail from '../successAdminAddedGroupDetail';
import sAdminDetailToTraveler from './adminDetailToTraveler.scss';

export const enhance = compose(
  withStyles(sAdminDetailToTraveler),
  withRouter,
);

function AdminDetailToTraveler(props) {
  const dispatch = useDispatch();
  const currentUser = useSelector(state => state.profile.currentUser);
  const selectedPlan = useSelector(state => state.plans.plan);
  const itemsAdded = useSelector(state => state.plans.addDetailToTraveler);
  const [transportationItems, setTransportationItems] = useState(null);
  const [housingItems, setHousingItems] = useState(null);
  const [activityItems, setActivityItems] = useState(null);
  const [selectedTransportation, setSelectedTransportation] = useState([]);
  const [selectedHousing, setSelectedHousing] = useState([]);
  const [selectedActivity, setSelectedActivity] = useState([]);
  const [saving, setSaving] = useState(false);
  const [showAdminAddSuccess, setShowAdminAddSuccess] = useState(false);
  const [availableOptions, setAvailableOptions] = useState(false);
  const [selectAll, setSelectAll] = useState(false);

  useEffect(() => {
    if (!!selectedPlan && !!selectedPlan.plan) {
      let rawTransportation = _get(selectedPlan.group_itinerary_byType, 'plan_transportation') || null;
      let rawHousing = _get(selectedPlan.group_itinerary_byType, 'plan_housing') || null;
      let rawActivity = _get(selectedPlan.group_itinerary_byType, 'plan_activity') || null;

      rawTransportation = rawTransportation && rawTransportation.filter(detail => !detail.removed);
      rawHousing = rawHousing && rawHousing.filter(detail => !detail.removed);
      rawActivity = rawActivity && rawActivity.filter(detail => !detail.removed);

      if ((!!rawTransportation &&  rawTransportation.length > 0) || (!!rawHousing && rawHousing.length > 0) || (!!rawActivity && rawActivity.length > 0)) {
        setAvailableOptions(true);
      }

      setTransportationItems(rawTransportation  || null);
      setHousingItems(rawHousing || null);
      setActivityItems( rawActivity || null);
    }
  }, [selectedPlan]);

  const toggleItem = (type, id) => {
    if (type === 'plan_transportation') {
      if (_includes(selectedTransportation, id)) {
        const tempRemove = _reject(selectedTransportation, function(item) {return item === id});
        setSelectedTransportation(tempRemove);
      } else {
        setSelectedTransportation([...selectedTransportation, id]);
      }
    }
    if (type === 'plan_housing') {
      if (_includes(selectedHousing, id)) {
        const tempRemove = _reject(selectedHousing, function(item) {return item === id});
        setSelectedHousing(tempRemove);
      } else {
        setSelectedHousing([...selectedHousing, id]);
      }
    }
    if (type === 'plan_activity') {
      if (_includes(selectedActivity, id)) {
        const tempRemove = _reject(selectedActivity, function(item) {return item === id});
        setSelectedActivity(tempRemove);
      } else {
        setSelectedActivity([...selectedActivity, id]);
      }
    }
  };

  const addItems = () => {
    if (selectedTransportation.length > 0 || selectedHousing.length > 0 || selectedActivity.length > 0) {
      const submitValues = {
        plans_user_ids: props.planUsers,
        plan_activity_ids: selectedActivity,
        plan_housing_ids: selectedHousing,
        plan_transportation_ids: selectedTransportation
      };

      dispatch(addDetailToTraveler(submitValues));
    }
  };

  useEffect(() => {
    if (!!itemsAdded) {
      if (itemsAdded.loading) {
        setSaving(true);
      }
      if(!!itemsAdded.data && !itemsAdded.loading) {
        setSaving(false);
        props.onClose(false);
        setSelectedActivity([]);
        setSelectedHousing([]);
        setSelectedTransportation([]);
        setShowAdminAddSuccess(true);
      }
      if (!!itemsAdded.error) {
        setSaving(false);
        // alert(itemsAdded.error);
      }
    }
  }, [itemsAdded]);

  useEffect(() => {
    if (selectAll) {
      setSelectedTransportation(_map(transportationItems, 'id'));
      setSelectedHousing(_map(housingItems, 'id'));
      setSelectedActivity(_map(activityItems, 'id'));
    } else {
      setSelectedTransportation([]);
      setSelectedHousing([]);
      setSelectedActivity([]);
    }
  }, [selectAll]);

  const clearState = () => {
    setSelectedTransportation([]);
    setSelectedHousing([]);
    setSelectedActivity([]);
    setSelectAll(false);
  };

  return (
    <>
      <ViaModal
        showing={props.show}
        onClose={() => {
          clearState();
          props.onClose(false);
        }}
        headerText="ADD DETAILS TO TRAVELER ITINERARIES"
      >
        <div className={sAdminDetailToTraveler['admin-detail-to-traveler']}>
          <div className={sAdminDetailToTraveler.subHeader}>
            {availableOptions ? (
              <Headline centered tag="h2" as="h3">
                {currentUser.first_name && currentUser.first_name.length > 0 ? `${currentUser.first_name}, w` : 'W'}hich Group Details would you like to add to {props.planUsers ? props.planUsers.length : ''} Traveler itineraries?
              </Headline>
            ) : (
              <Headline centered tag="h2" as="h3">
                {currentUser.first_name && currentUser.first_name.length > 0 ? `${currentUser.first_name}, t` : 'T'}here are no group travel details added to the group itinerary.
              </Headline>
            )}

          </div>
          <div className={sAdminDetailToTraveler.content}>
            <div
              className={sAdminDetailToTraveler['toggle-link']}
              onClick={() => {setSelectAll(!selectAll)}}
            >
              <Paragraph size="small" color="primary" bold>{selectAll ? `CLEAR ALL GROUP DETAILS` : `SELECT ALL GROUP DETAILS`}</Paragraph>
            </div>
            <div className={sAdminDetailToTraveler['content-header']}>
              <Headline tag="h3" as="h3" italic>
                Group Transportation
              </Headline>
            </div>
            {!!transportationItems && transportationItems.length > 0 ? (
              transportationItems.map(item => (
                <div key={item.id} className={sAdminDetailToTraveler.itoggle}>
                  <ItineraryToggle
                    iName={item.nickname ? item.nickname : item.carrier_name}
                    iType={item.tp_transportation_type_name}
                    iStart={item.departure_date}
                    iEnd={item.arrival_date}
                    icon={Number(item.tp_transportation_type_id)}
                    iLocations={(!!item.departure_location && !!item.arrival_location) ?
                      `${item.departure_location.locality}, ${item.departure_location.country_common_name} to
                     ${item.arrival_location.locality}, ${item.arrival_location.country_common_name}`
                      : ''}
                    isActive={_includes(selectedTransportation, item.id)}
                    onClick={() => toggleItem('plan_transportation', item.id)}
                    type="add"
                    detailType="transportation"
                  />
                </div>
              ))
            ) : (
              <Paragraph>There are no group transportation details added yet.</Paragraph>
            )}
          </div>
          <div className={sAdminDetailToTraveler.content}>
            <div className={sAdminDetailToTraveler['content-header']}>
              <Headline tag="h3" as="h3" italic>
                Group Housing
              </Headline>
            </div>
            {!!housingItems && housingItems.length > 0 ? (
              housingItems.map(item => (
                <div key={item.id} className={sAdminDetailToTraveler.itoggle}>
                  <ItineraryToggle
                    iName={item.nickname ? item.nickname : item.name}
                    iType={item.tp_housing_type_name}
                    iStart={item.arrival_date}
                    iEnd={item.departure_date}
                    icon={Number(item.tp_housing_type_id)}
                    iLocations={(!!item.location) ?
                      `${item.location.locality}, ${item.location.country_common_name}`
                      : ''}
                    isActive={_includes(selectedHousing, item.id)}
                    onClick={() => toggleItem('plan_housing', item.id)}
                    type="add"
                    detailType="housing"
                  />
                </div>
              ))
            ) : (
              <Paragraph>There are no group housing details added yet.</Paragraph>
            )}
          </div>
          <div className={sAdminDetailToTraveler.content}>
            <div className={sAdminDetailToTraveler['content-header']}>
              <Headline tag="h3" as="h3" italic>
                Group Activities
              </Headline>
            </div>
            {!!activityItems && activityItems.length > 0 ? (
              activityItems.map(item => (
                <div key={item.id} className={sAdminDetailToTraveler.itoggle}>
                  <ItineraryToggle
                    iName={item.nickname ? item.nickname : item.name}
                    iType={item.tp_activity_type_name}
                    iStart={item.start_date}
                    iEnd={item.end_date}
                    icon={Number(item.tp_activity_type_id)}
                    iLocations={(!!item.location) ?
                      `${item.location.locality}, ${item.location.country_common_name}`
                      : ''}
                    isActive={_includes(selectedActivity, item.id)}
                    onClick={() => toggleItem('plan_activity', item.id)}
                    type="add"
                    detailType="activity"
                  />
                </div>
              ))
            ) : (
              <Paragraph>There are no group activity details added yet.</Paragraph>
            )}
          </div>
          <div className={sAdminDetailToTraveler.footer}>
            <div className={sAdminDetailToTraveler['footer-confirm']}>
              {!availableOptions &&
                <Headline tag="h2" as="h3" centered>
                  Would you like to build your itinerary?
                </Headline>
              }
            </div>
            <div className={sAdminDetailToTraveler['footer-button-wrapper']}>
              <div className={sAdminDetailToTraveler['button-content']}>
                <Button
                  display="secondary"
                  kind="solid"
                  size="medium"
                  onClick={() => {
                    clearState();
                    props.onClose(false);
                  }}
                >
                  Cancel
                </Button>
              </div>
              {availableOptions ? (
                <div className={sAdminDetailToTraveler['button-content']}>
                  <Button
                    display="primary"
                    kind="solid"
                    size="medium"
                    type="submit"
                    disabled={
                      selectedTransportation.length === 0 &&
                      selectedHousing.length === 0 &&
                      selectedActivity.length === 0
                    }
                    loading={saving}
                    onClick={() => {
                      addItems();
                    }}
                  >
                    Save Details to Selected Travelers
                  </Button>
                </div>
              ) : (
                <div className={sAdminDetailToTraveler['button-content']}>
                  <Button
                    display="primary"
                    kind="solid"
                    size="medium"
                    type="submit"
                    onClick={() => {
                      props.onClose(false);
                      props.history.push(`/plans/group-itinerary/${props.planId}`);
                    }}
                  >
                    Yes, Build Itinerary
                  </Button>
                </div>
              )}
            </div>
          </div>
        </div>
      </ViaModal>
      <SuccessAdminAddedGroupDetail
        show={showAdminAddSuccess}
        onClose={() => setShowAdminAddSuccess(false)}
        planUsers={props.planUsers}
        planId={props.planId}
      />
    </>
  );
}

AdminDetailToTraveler.propTypes = {
  show: propTypes.bool.isRequired,
  onClose: propTypes.func.isRequired,
  planId: propTypes.string.isRequired,
  planUsers: propTypes.array,
};

export default enhance(AdminDetailToTraveler);
